/**
 * CockpitRequest
 * @author ftgibran
 */
import moment from 'moment'
import {Model, IResource, Collection, ID} from 'simpli-web-sdk'
import {HttpIgnore, ResponseFill, ValidationRequired, ValidationCNPJ} from 'simpli-web-sdk'
import {Period} from '@/enums/Period'
import {GroupBy} from '@/enums/GroupBy'
import {Region} from '@/enums/Region'
import {UF} from '@/enums/UF'
import {ItrackCollection} from '@/helpers'
import * as Helper from '@/helpers'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import {TipoSistema} from '@/enums/TipoSistema'
import {DeliverySlaStatus} from '@/enums/DeliverySlaStatus'
import Motorista from '@/model/resource/Motorista'

@HttpIgnore()
export default class CockpitRequest extends Model {
  readonly $name: string = 'CockpitRequest'

  idFilial = Helper.getIdFilial()
  allCentroDeCusto = ItrackCollection.allCentroDeCusto.prependNull('app.all')

  allTipoInsumo = ItrackCollection.allTipoInsumo.prependNull('app.all')

  @ResponseFill()
  @ValidationRequired()
  period = Period.HOURLY

  @ResponseFill()
  @ValidationRequired()
  groupBy = Helper.isPiquetur() ? GroupBy.CTE : GroupBy.ID_CARGA

  @ResponseFill()
  @ValidationRequired()
  dataInicio: string = moment().format()

  @ResponseFill()
  @ValidationRequired()
  dataFim: string | null = moment().format()

  @ResponseFill()
  @ValidationRequired()
  uf: UF | null = null

  @ResponseFill('cte')
  cte: string | null = null

  @ResponseFill('manifesto')
  manifesto: string | null = null

  @ResponseFill('idTipoOcorrencia')
  @ValidationRequired()
  idTipoOcorrencia: number | null = null

  @ResponseFill('idRespFiltroFilial')
  @ValidationRequired()
  idRespFiltroFilial: ID | null = Helper.getIdFilial()

  @ResponseFill()
  @ValidationRequired()
  region: Region | null = null

  @ResponseFill()
  @ValidationCNPJ()
  documentResponsavel: string | null = null

  @ResponseFill()
  @ValidationCNPJ()
  documentResponsavel2: string | null = null

  @ResponseFill()
  @ValidationCNPJ()
  documentDestinatario: string | null = null

  @ResponseFill()
  cidade: string | null = null

  @ResponseFill()
  nroNotaFiscal: string | null = null

  @ResponseFill()
  sigla: string | null = null

  @ResponseFill()
  allowNotification = Helper.getAllowNotification()

  @ResponseFill()
  updateAutomatically = Helper.getUpdateAutomaticallyCockpit()

  @ResponseFill('idCentroDeCusto')
  @ValidationRequired()
  idCentroDeCusto: number | null = null

   @ResponseFill('slaPendente')
   slaStatus: DeliverySlaStatus | null = null

  @ResponseFill('idMotoristaPk')
  idMotorista: ID | null = null

  get centroDeCustoResource() {
    return this.allCentroDeCusto.get(this.idCentroDeCusto)
  }
  set centroDeCustoResource(val: IResource | null) {
    this.idCentroDeCusto = val && val.$id as number || null
  }

    @ResponseFill('idInsumo')
    @ValidationRequired()
    idInsumo: number | null = null

    get insumoResource() {
        return this.allCentroDeCusto.get(this.idInsumo)
    }
    set insumoCustoResource(val: IResource | null) {
        this.idInsumo = val && val.$id as number || null
    }

    @ResponseFill('idTipoFinalizacao')
    @ValidationRequired()
    idTipoFinalizacao: number | null = null

    get tipoFinalizacaoResource() {
        return this.allSistema.get(this.idTipoFinalizacao)
    }
    set tipoFinalizacaoResource(val: IResource | null) {
        this.idTipoFinalizacao = val && val.$id as TipoSistema || null
    }

    @ResponseFill('idTipoCriacao')
    @ValidationRequired()
    idTipoCriacao: number | null = null

    get tipoCriacaoResource() {
        return this.allSistema.get(this.idTipoCriacao)
    }
    set tipoCriacaoResource(val: IResource | null) {
        this.idTipoCriacao = val && val.$id as TipoSistema || null
    }

  allRegion = ItrackCollection.allRegion.prependNull('app.all')
  periodCollection = ItrackCollection.getPeriodCollection()
  groupByCollection = ItrackCollection.getGroupByNoDefaultCollection()
  monthCollection = ItrackCollection.getMonthCollection()
  yearCollection = ItrackCollection.getYearCollection()
  allTipoOcorrencia = ItrackCollection.allTipoOcorrenciaFiltro
  tipoOcorrenciaNaoDevolvidaCollection = new Collection(TipoOcorrencia)
  tipoOcorrenciaDevolvidaCollection = new Collection(TipoOcorrencia)
  allSistema = ItrackCollection.allSistema
  allSlaStatus = ItrackCollection.allSlaStatus.prependNull('app.all')
  allMotorista = ItrackCollection.allMotoristaFiltro

  get ufCollection() {
    return ItrackCollection.getUfCollection(this.region).prependNull('app.all')
  }

  get groupByResource() {
    return this.groupByCollection.get(this.groupBy)
  }
  set groupByResource(val: IResource | null) {
    this.groupBy = val && val.$id as GroupBy || GroupBy.ID_CARGA
  }

  get regionResource() {
    return this.allRegion.get(this.region)
  }
  set regionResource(val: IResource | null) {
    this.region = val && val.$id as Region || null
  }

  get tipoOcorrenciaResource() {
    return this.tipoOcorrenciaNaoDevolvidaCollection.get(this.idTipoOcorrencia)
  }
  set tipoOcorrenciaResource(val: IResource | null) {
    this.idTipoOcorrencia = val && val.$id as number || null
  }

  get ufResource() {
    return this.ufCollection.get(this.uf)
  }
  set ufResource(val: IResource | null) {
    this.uf = val && val.$id as UF || null
  }

  get dayCollection() {
    return ItrackCollection.getDayCollection(this.dataInicio)
  }

  get slaStatusResource() {
      return this.allSlaStatus.get(this.slaStatus)
  }
  set slaStatusResource(val: IResource | null) {
      this.slaStatus = val && val.$id as DeliverySlaStatus || null
  }

  get periodResource() {
    return this.periodCollection.get(this.period)
  }
  set periodResource(val: IResource | null) {
    this.period = val && val.$id as Period || Period.DAILY
  }

  get day() {
    return Number(moment(this.dataInicio).format('DD')) || 0
  }
  set day(val: number) {
    this.dataInicio = moment(this.dataInicio).date(val).format()
  }

  get month() {
    return Number(moment(this.dataInicio).format('MM')) || 0
  }
  set month(val: number) {
    this.dataInicio = moment(this.dataInicio).month(val - 1).format()
  }

  get year() {
    return Number(moment(this.dataInicio).format('YYYY')) || 0
  }
  set year(val: number) {
    this.dataInicio = moment(this.dataInicio).year(val).format()
  }

  get dayResource() {
    return this.dayCollection.get(this.day)
  }
  set dayResource(val: IResource | null) {
    this.day = val && val.$id as number || moment().date()
  }

  get monthResource() {
    return this.monthCollection.get(this.month)
  }
  set monthResource(val: IResource | null) {
    this.month = val && val.$id as number || moment().month()
  }

  get yearResource() {
    return this.yearCollection.get(this.year)
  }
  set yearResource(val: IResource | null) {
    this.year = val && val.$id as number || moment().year()
  }

  get motoristaResource() {
    return this.allMotorista.get(this.idMotorista)
  }

  set motoristaResource(val: Motorista | null) {
    this.idMotorista = val && val.$id || null
  }
}
